import Image from 'next/legacy/image';
import { CacheStorageMedia } from '@sy/ssr-types';
import {
	Quote,
	QuoteAuthorAvatar,
	QuoteAuthorJobTitle,
	QuoteAuthorName,
	QuoteAuthorSeparator,
	QuoteAuthorWrapper,
	QuoteContent,
	QuoteCopy,
	QuoteWrapper,
} from './CaseStudyQuote.styles';

const IMAGE_HEIGHT = 44;

const CaseStudyQuote = ({
	quote,
	name,
	jobTitle,
	copy,
	image,
	backgroundColor,
}: CaseStudyQuoteProps) => {
	return (
		<QuoteWrapper background={backgroundColor}>
			<QuoteContent>
				<Quote>{quote}</Quote>
				{name && (
					<QuoteAuthorWrapper>
						{image?.url &&
							image?.dimensions &&
							image?.dimensions.height > 0 && (
								<QuoteAuthorAvatar>
									<Image
										src={image.url}
										alt={image.description}
										height={IMAGE_HEIGHT}
										width={
											(IMAGE_HEIGHT * image.dimensions.width) /
											image.dimensions.height
										}
									/>
								</QuoteAuthorAvatar>
							)}
						<QuoteAuthorName>{name}</QuoteAuthorName>
						{jobTitle && (
							<>
								<QuoteAuthorSeparator>&#8226;</QuoteAuthorSeparator>
								<QuoteAuthorJobTitle>{jobTitle}</QuoteAuthorJobTitle>
							</>
						)}
					</QuoteAuthorWrapper>
				)}
				{copy && <QuoteCopy>{copy}</QuoteCopy>}
			</QuoteContent>
		</QuoteWrapper>
	);
};

export type CaseStudyQuoteProps = {
	quote?: string;
	name?: string;
	jobTitle?: string;
	copy?: string;
	image?: CacheStorageMedia;
	backgroundColor?: 'darkBlue' | 'blue' | 'lightBlue';
};

export default CaseStudyQuote;
